module.exports = __webpack_public_path__ + "media/images/google-wallet-5ef210c47effbed9b68f32151866e771.png";